export default __webpack_public_path__ + "static/media/Checkmark.3d461056.svg";